import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './i18n';
import { Provider } from 'react-redux';
// import reportWebVitals from './reportWebVitals';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { store } from './state';
import Application from './application';
import { contextProvider } from './utils/contextProvider';

const [ctx, ApplicationProvider] = contextProvider<{
  backgroundColor: string;
}>({ backgroundColor: '#f3f4f8' });

export const ApplicationCtx = ctx;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ApplicationProvider>
        <QueryClientProvider client={queryClient}>
          <Application />
        </QueryClientProvider>
      </ApplicationProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
